import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  viewPlansButton: {
    defaultMessage: 'View Plans',
    description: 'Button text to view available subscription plans',
    id: '1R11Bf',
  },
});
